export const MORTGAGE_TYPES = {
  TITLE: "Title",
  LENDER: "Lender",
  UNDERWRITER: "Underwriter",
};
